import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, Select, MenuItem } from '@mui/material';

const FormSelectField = React.memo(({ name, value, onChange, placeholder, options, required = true }) => {
  return (
    <FormControl fullWidth required={required}>
      <Select
        name={name}
        value={value}
        onChange={onChange}
        displayEmpty
        sx={{
          borderRadius: 2,
          backgroundColor: '#fff',
          border: '1px solid #e2e8f0',
          '& fieldset': {
            border: 'none',
          },
          '&:hover': {
            '& fieldset': {
              border: 'none',
            },
            border: '1px solid #cbd5e1',
          },
          '&.Mui-focused': {
            border: '1px solid #0f172a',
            '& fieldset': {
              border: 'none',
            },
          },
          '& .MuiSelect-select': {
            py: 1.5,
            px: 2,
            color: value ? '#000' : '#64748b',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
        }}
      >
        <MenuItem value="" disabled>
          {placeholder}
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
});

FormSelectField.displayName = 'FormSelectField';

FormSelectField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  required: PropTypes.bool,
};

export default FormSelectField;
